// Wraps a trailing arrow glyph in button labels with <span class="btn__arrow"> so it can slide
// independently on hover (see .btn__arrow in _buttons.scss).
export default function initButtonArrows() {
  const ARROW_CHARS = ['→', '↗', '↘', '↙', '↖', '↓', '↑', '←', '➔', '➜', '➝'];
  const SELECTOR = '.btn, .wp-block-button__link';

  document.querySelectorAll(SELECTOR).forEach((el) => {
    if (el.querySelector('.btn__arrow')) return;

    // Find the last non-empty text node in the element (skips nested
    // elements like icons so we only ever touch real label text).
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let lastTextNode = null;
    let node = walker.nextNode();
    while (node) {
      if (node.textContent.trim().length) lastTextNode = node;
      node = walker.nextNode();
    }
    if (!lastTextNode) return;

    const text = lastTextNode.textContent;
    const trimmedEnd = text.replace(/\s+$/, '');
    const lastChar = trimmedEnd.slice(-1);
    if (!ARROW_CHARS.includes(lastChar)) return;

    const splitIndex = text.lastIndexOf(lastChar);
    const before = text.slice(0, splitIndex);

    const arrowSpan = document.createElement('span');
    arrowSpan.className = 'btn__arrow';
    arrowSpan.setAttribute('aria-hidden', 'true');
    arrowSpan.textContent = lastChar;

    const frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode(before));
    frag.appendChild(arrowSpan);
    lastTextNode.replaceWith(frag);
  });
}
